module.exports = __webpack_public_path__ + "img/flexadora-02.3c7d6ceb.jpg";